import { render, staticRenderFns } from "./consultationList.vue?vue&type=template&id=1ffde1e8&scoped=true&"
import script from "./consultationList.vue?vue&type=script&lang=js&"
export * from "./consultationList.vue?vue&type=script&lang=js&"
import style0 from "./consultationList.vue?vue&type=style&index=0&id=1ffde1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffde1e8",
  null
  
)

component.options.__file = "consultationList.vue"
export default component.exports